import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import {
    BlobTypeStoreReadSettingsAdapter,
    blobTypeStoreReadSettingsAdapts
} from './blob-type-store-read-settings.adapter';
import { AzureDataLakeStoreReadSettings } from 'app/model/pipeline/copysource/store-read-settings/azure-data-lake-store-read-settings';
import { FilePathMode } from 'app/registries/consts/metadata-consts';
import { CopySource } from 'app/model/pipeline/copysource/copysource';
import { ValueAdapter } from 'app/model/adapters/value.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureDataLakeStoreReadSettings),
    asynchronous: true,
    adapts: {
        ...blobTypeStoreReadSettingsAdapts,
        deleteFilesAfterCompletion: '*',
        listBefore: '*',
        listAfter: '*'
    }
})
export class AzureDataLakeStoreReadSettingsAdapter extends BlobTypeStoreReadSettingsAdapter<
    AzureDataLakeStoreReadSettings,
    Model.StoreReadSettings
> {
    protected override async _toModel(
        resource: Model.StoreReadSettings,
        copySource: CopySource
    ): Promise<AzureDataLakeStoreReadSettings> {
        const model = await super._toModel(resource, copySource);
        if (model != null && resource != null && (resource.listBefore || resource.listAfter)) {
            model.filePathMode = FilePathMode.NameRange;
            ValueAdapter.toModel(model, AzureDataLakeStoreReadSettings.LIST_BEFORE, resource.listBefore);
            ValueAdapter.toModel(model, AzureDataLakeStoreReadSettings.LIST_AFTER, resource.listAfter);
        }
        ValueAdapter.toModel(
            model,
            AzureDataLakeStoreReadSettings.DELETE_FILE_AFTER_COMPLETION,
            resource.deleteFilesAfterCompletion
        );

        return model;
    }

    protected override async _toResource(settings: AzureDataLakeStoreReadSettings): Promise<Model.StoreReadSettings> {
        const resource = await super._toResource(settings);
        if (settings.filePathMode === FilePathMode.NameRange) {
            resource.listBefore =
                ValueAdapter.toResource(settings, AzureDataLakeStoreReadSettings.LIST_BEFORE) || undefined;
            resource.listAfter =
                ValueAdapter.toResource(settings, AzureDataLakeStoreReadSettings.LIST_AFTER) || undefined;
        }
        resource.deleteFilesAfterCompletion = ValueAdapter.toResource(
            settings,
            AzureDataLakeStoreReadSettings.DELETE_FILE_AFTER_COMPLETION
        );

        return resource;
    }
}
